import * as React from "react";
import { cn } from "@/lib/utils";

export interface FloatingLeftButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: React.ReactNode;
}

export function FloatingLeftButton({
  icon,
  className,
  children,
  ...props
}: FloatingLeftButtonProps) {
  return (
    <button
      type="button"
      className={cn(
        "bg-transparent",
        "w-12 h-9",
        "flex items-center justify-center",
        "transition-all duration-200",
        "text-white",
        "active:scale-95",
        "hover:cursor-pointer hover:brightness-95 hover:saturate-95",
        className,
      )}
      style={{
        imageRendering: "pixelated",
        backgroundImage:
          "url(https://cdn.navalabs.io/assets/floating-button_6WYs2s.png)",
        backgroundSize: "100% 100%",
        backgroundPosition: "center",
      }}
      {...props}
    >
      {icon || children}
    </button>
  );
}
